import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 14l5-5 5 5H7z"
}), 'ArrowDropUpSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowDropUpSharp.js
// module id = 2096
// module chunks = 2